import styled from 'styled-components';
import { PageHeaderWrapper } from '@ui';

export const OfficeHoursSC = styled(PageHeaderWrapper)`
  .header-title-extra {
    display: flex;
    align-items: center;
    gap: 16px;

    .e-visits-workspace-selector {
      width: 270px;
    }
  }
` as typeof PageHeaderWrapper;
